import { createAction } from '@reduxjs/toolkit';

// default
export const TBM = 'tbm';
export const TBM_SLICE_NAME = `${TBM}Slice`;

// action
const GET_TBM_STATUS_LIST = `${TBM}/getTbmStatusList`;
const GET_TBM_DETAIL = `${TBM}/getTbmDetail`;
const GET_TBM_FILE = `${TBM}/getTbmFile`;
const GET_TBM_ATTENDANCE = `${TBM}/getTbmAttendance`;
// createAction
export const getTbmStatusListAction = createAction(GET_TBM_STATUS_LIST);
export const getTbmDetailAction = createAction(GET_TBM_DETAIL);
export const getTbmFileAction = createAction(GET_TBM_FILE);
export const getTbmAttendanceAction = createAction(GET_TBM_ATTENDANCE);
// actions
export const actions = {
  GET_TBM_STATUS_LIST,
  GET_TBM_DETAIL,
  GET_TBM_FILE,
  GET_TBM_ATTENDANCE
};
